import {
  AssessmentsPath,
  AuditLogsPath,
  CalendarPath,
  LocationsPath,
  PendingSignOffsPath,
  ReportsPath,
  ResidentsPath,
  ShiftHandoverDashboardPath,
  StatusFlagsPath,
  UsersPath,
} from "app/constants/routePaths";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { CheckHeartIcon } from "ui/gluestack/icon/CheckHeart";
import { PeopleIcon } from "ui/gluestack/icon/People";
import { LocationMarkerIcon } from "ui/gluestack/icon/LocationMarker";
import { CalendarIcon } from "ui/gluestack/icon/CalendarIcon";
import { FileIcon } from "ui/gluestack/icon/File";
import { FlagIcon } from "ui/gluestack/icon/FlagIcon";
import { ReportsIcon } from "ui/gluestack/icon/ReportsIcon";
import { AuditIcon } from "ui/gluestack/icon/AuditIcon";
import { PendingSignOffsIcon } from "ui/gluestack/icon/PendingSignOffsIcon";

export const NAVIGATION_MENU_ITEMS = [
  {
    icon: CalendarIcon,
    path: CalendarPath,
    label: "Calendar",
    permission: PermissionsEnums.VIEW_CALENDAR_EVENT,
  },
  {
    icon: CheckHeartIcon,
    path: UsersPath,
    label: "Users & Roles",
    permission: PermissionsEnums.VIEW_USER,
    group: "Admin",
  },
  {
    icon: PeopleIcon,
    path: ResidentsPath,
    label: "Residents",
    permission: PermissionsEnums.VIEW_RESIDENT,
  },
  {
    icon: FileIcon,
    path: ShiftHandoverDashboardPath,
    label: "Shift Handover",
    permission: PermissionsEnums.VIEW_SHIFT_HANDOVER,
  },
  {
    icon: ReportsIcon,
    path: ReportsPath,
    label: "Reports",
    permission: PermissionsEnums.GENERATE_RESIDENT_REPORT,
  },
  {
    icon: PendingSignOffsIcon,
    path: PendingSignOffsPath,
    label: "Pending Sign-Offs",
    permission: [
      PermissionsEnums.SIGN_OFF_ADMISSION_CHECKLIST_FORM,
      PermissionsEnums.SIGN_OFF_MEDICATION,
    ],
  },
  {
    icon: LocationMarkerIcon,
    path: LocationsPath,
    label: "Locations",
    permission: PermissionsEnums.VIEW_LOCATION,
    group: "Admin",
  },
  {
    icon: FlagIcon,
    path: StatusFlagsPath,
    label: "Status Flags",
    permission: PermissionsEnums.VIEW_STATUS_FLAG,
    group: "Admin",
  },
  {
    icon: FileIcon,
    path: AssessmentsPath,
    label: "Assessments",
    permission: [PermissionsEnums.CREATE_FORM, PermissionsEnums.UPDATE_FORM],
    group: "Admin",
  },
  {
    icon: AuditIcon,
    path: AuditLogsPath,
    label: "Audit Logs",
    permission: PermissionsEnums.VIEW_AUDIT_LOG,
    group: "Admin",
  },
];
